import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
    if (sessionStorage.getItem('roadmap-scroll-hinted')) return

    this.timer = setTimeout(() => {
      const el = this.element
      if (el.scrollWidth <= el.clientWidth + 8) return
      sessionStorage.setItem('roadmap-scroll-hinted', '1')

      const distance = Math.min(96, Math.round(el.clientWidth * 0.18))
      el.scrollTo({ left: distance, behavior: 'smooth' })
      this.back = setTimeout(() => el.scrollTo({ left: 0, behavior: 'smooth' }), 750)
    }, 500)
  }

  disconnect () {
    clearTimeout(this.timer)
    clearTimeout(this.back)
  }
}
